import Head from 'next/head'

import Products from '@/components/Products'
import { HeadingM, BodyM } from '@/components/Typography'

import NotFoundIcon from '../images/not-found'

const NotFound = () => (
  <>
    <Head>
      <title>Página não encontrada</title>
    </Head>
    <div className="errorContent ecs-container eu-sm-m et-ta-center">
      <NotFoundIcon />
      <HeadingM className="eu-sm-s">Página não encontrada.</HeadingM>
      <BodyM className="eu-sm-m">
        O link que você entrou está quebrado ou a página foi removida.
      </BodyM>
      <Products />
    </div>
  </>
)

export default NotFound
